

import React, { useState } from "react";
import ModalThemMoi from "../../ThemMoi/ModalThemMoi";


const BtnSua = ({ item, onReload }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSaved = () => {
    if (onReload) onReload();
  };
  return (
    <>
      <a type="button" className="popover-basic" onClick={handleShow}>
        <img src="/app-assets/images/icon-edit-v2.png" title="Sửa" />
      </a>
      {show && (
        <ModalThemMoi
          show={show}
          onHide={handleClose}
          item={item}
          onSaved={handleSaved}
        />
      )}
    </>
  );
};

export default BtnSua;
